import HyperDiv from "components/ProjectNonSpecificComponents/Elements/HyperDiv/HyperDiv"
import React, { useContext, useState } from "react"
import { useEffect } from "react"
import { useStore } from "../Contexts/GlobalStoreContext"
import UserRequestTable from "../Elements/Tables/organisms/UserRequestTable"
import UserSubmitRequest from "../Elements/AdminForm/organisms/UserSubmitRequest"
import { TUserUISection } from "../Stores/GlobalStore"
import { observer } from "mobx-react"
import { useFormStore } from "../Contexts/FormStoreContext"
import PreferencesNavBarTabSelectionButton from "../Elements/Navigation/atoms/Buttons/PreferencesNavBarTabSelectionButton"
import { useTranslation } from "react-i18next"
import Whitespace from "components/ProjectNonSpecificComponents/Elements/Whitespace"
import {
	HEIGHT_WITH_BIG_NAV_AND_FOOTER,
	HEIGHT_WITH_NAV_AND_FOOTER,
} from "../Constants/GLOBAL_CONSTANTS"
import { ISettings } from "../Interfaces/FormsInterface"
import AppRequests from "../API/AppRequests/AppRequests"
import { UserContext } from "../Contexts/UserContext"
import { lostOrFinishedUserSession } from "../API/Functions/lostOrFinishedUserSession"
import ModalWithSepLine from "../Elements/Global/molecules/Modals/ModalWithSepLine"
import parse from "html-react-parser"
import i18n from "i18n"

interface Props {}

export const getLastViewedSection = (): any => localStorage.getItem("userSection")

const UserOverviewPage = observer(({}: Props) => {
	const store = useStore()
	const formStore = useFormStore()
	const { t } = useTranslation()
	const { setUser } = useContext(UserContext)
	const { instanceAnonymousUsers, selectedUserUISection } = store
	// ! TECHNICAL DEBT: 3184, replace this with dynamic key ([parsedkey])
	const isEN = i18n.language === "en"

	const [dateModalOpen, setDateModalOpen] = useState<boolean>(false)

	useEffect(() => {
		const fetchAndSetSettings = async () => {
			store.setLoaderOverlayOpen(true)

			const { ok, data, statusCode } = await AppRequests("Setting").get<ISettings>("get-settings")

			if (ok && data) {
				formStore.mergeSettingsDataSafely(data)
			} else if (statusCode == 401) {
				setUser(undefined)
				lostOrFinishedUserSession(store)
			} else {
				store.setInfoModalConfig({
					type: "fail",
					titleKey: "settings.failed",
					descriptionKey: "settings.failedDescription",
				})
			}
			store.triggerSessionTimeout()
			store.setLoaderOverlayOpen(false)
		}
		fetchAndSetSettings()
	}, [])

	const storeLastSectionView = (value: TUserUISection) => localStorage.setItem("userSection", value)

	useEffect(() => {
		if (selectedUserUISection) {
			storeLastSectionView(selectedUserUISection)
		} else {
			return store.setSelectedUserUISection("newRequest")
		}
	}, [selectedUserUISection])

	const { bigLogo } = formStore.settingsData.personalize
	const { cookieBar } = formStore.settingsData.additionalInfo

	useEffect(() => {
		if (!cookieBar) return
        let _modal = !!cookieBar?.isModal
		if (!_modal) return setDateModalOpen(false)

		let _emptyInfo = isEN ? !!cookieBar?.textEN : !!cookieBar?.textLV
		if (!_emptyInfo) return setDateModalOpen(false)
		
		let _cookieOk = sessionStorage.getItem("cookie-OK")
		!_cookieOk && setDateModalOpen(true)
	}, [cookieBar, isEN])

	return (
		<HyperDiv
			width="100%"
			height={bigLogo ? HEIGHT_WITH_BIG_NAV_AND_FOOTER : HEIGHT_WITH_NAV_AND_FOOTER}
			direction="column"
			alignedTop
			className="justify-start"
		>
			{!instanceAnonymousUsers && (
				<HyperDiv
					direction="row"
					alignedTop
					height="50px"
					width="100vw"
					centeredX
					style={{ background: "white" }}
				>
					<PreferencesNavBarTabSelectionButton
						selected={selectedUserUISection == "newRequest"}
						onClick={() => store.setSelectedUserUISection("newRequest")}
						children={t("button.newRequest")}
					/>
					<Whitespace x="0.5" h />
					<PreferencesNavBarTabSelectionButton
						selected={selectedUserUISection == "myRequests"}
						onClick={() => store.setSelectedUserUISection("myRequests")}
						children={t("button.myRequests")}
					/>
				</HyperDiv>
			)}

			{selectedUserUISection == "newRequest" && <UserSubmitRequest />}
			{selectedUserUISection == "myRequests" && !instanceAnonymousUsers && <UserRequestTable />}

			{dateModalOpen && (
				<ModalWithSepLine
					isTransparant
					top="95%"
					left="50%"
					width="80vw"
					onClose={() => {
						setDateModalOpen(false)
						sessionStorage.setItem("cookie-OK", "true")
					}}
				>
					<div className="flex-col">
						{cookieBar?.isRichText
							? isEN
								? parse(String(cookieBar?.textEN))
								: parse(String(cookieBar?.textLV))
							: isEN
							? cookieBar?.textEN
							: cookieBar?.textLV}
					</div>
				</ModalWithSepLine>
			)}
		</HyperDiv>
	)
})

export default UserOverviewPage
